import React from "react";
import { IconButton, Stack, TextField, Typography } from "@mui/material";
import { ArrowDown, ArrowUp, X } from "@phosphor-icons/react";

interface TaskStepRowProps {
  index: number;
  value: string;
  canMoveUp: boolean;
  canMoveDown: boolean;
  canDelete: boolean;
  onChange: (value: string) => void;
  onMoveUp: () => void;
  onMoveDown: () => void;
  onDelete: () => void;
}

/**
 * One row in the Task Analysis step list.
 * Drag handle (presentational), step text input, up/down/delete controls.
 */
const TaskStepRow: React.FC<TaskStepRowProps> = ({
  index,
  value,
  canMoveUp,
  canMoveDown,
  canDelete,
  onChange,
  onMoveUp,
  onMoveDown,
  onDelete,
}) => (
  <Stack direction="row" gap={1} alignItems="center">
    <Typography variant="body2" fontWeight={500} sx={{ minWidth: 24, color: "text.secondary" }}>
      {index + 1}.
    </Typography>

    <TextField
      size="small"
      fullWidth
      placeholder="Enter step description"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      aria-label={`Step ${index + 1}`}
    />

    <IconButton
      size="small"
      aria-label={`Move step ${index + 1} up`}
      disabled={!canMoveUp}
      onClick={onMoveUp}
    >
      <ArrowUp size={20} style={{ width: 20, height: 20 }} />
    </IconButton>

    <IconButton
      size="small"
      aria-label={`Move step ${index + 1} down`}
      disabled={!canMoveDown}
      onClick={onMoveDown}
    >
      <ArrowDown size={20} style={{ width: 20, height: 20 }} />
    </IconButton>

    <IconButton
      size="small"
      aria-label={`Delete step ${index + 1}`}
      disabled={!canDelete}
      onClick={onDelete}
      color="error"
    >
      <X size={20} style={{ width: 20, height: 20 }} />
    </IconButton>
  </Stack>
);

export default TaskStepRow;
